import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/federaciones`;

export const getFederaciones = async (navigate) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}`,
      {
        method: "GET",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener las federaciones");
  } catch (error) {
    throw error;
  }
};
